<template>
  <div>
    <div class="searchArea">
      <a-range-picker v-model:value="inputs.dateRange" :placeholder="['开始时间', '结束时间']" @change="handleChangeDate"
        style="width: 300px; margin-right: 10px;" />
      <a-radio-group v-model:value="inputs.dateType" @change="handleChangeDateType" style="margin-right: 20px">
        <a-radio-button value="today">今天</a-radio-button>
        <a-radio-button value="week">本周</a-radio-button>
        <a-radio-button value="month">本月</a-radio-button>
        <a-radio-button value="year">近一年</a-radio-button>
      </a-radio-group>

      <a-button type="primary" shape="circle" @click="search('')">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </div>

    <a-table class="ant-table-striped" :columns="columns" :data-source="data"
      :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id"
      :scroll="{ y: 550 }" :pagination="{ pageSize: $store.state.tableSize, total, current }" @change="search">
      <template #operation="{ record }">
        <div class="flex_sa">
          <span v-if="record.doctorName">
            <a @click="goDoctor(record)">查看医生</a>
          </span>
          <span v-if="record.microTestResult">
            <a @click="goMicroTest(record)">查看微测</a>
          </span>
        </div>
      </template>

      <template v-for="col in ['doctorName', 'microTestResult']" #[col]="{ text }" :key="col">
        <div class="clickable">
          <span>{{ text }}</span>
          <form-outlined style="color:#40a9ff;cursor: pointer;" />
        </div>
      </template>
      <template v-for="col in ['phone']" #[col]="{ record }" :key="col">
        <div>
          <span>{{ record.customer.mobile }}</span>
        </div>
      </template>
      <template v-for="col in ['customerName']" #[col]="{ record }" :key="col">
        <div>
          <span>{{ record.customer.name }}</span>
        </div>
      </template>
    </a-table>
  </div>
</template>

<style scoped>
:deep(.ant-table-tbody > tr > td, .ant-table-thead > tr > th) {
  padding: 10px 8px;
}

.clickable {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>

<script>
import { SearchOutlined, FormOutlined } from "@ant-design/icons-vue";
import moment from "moment";
import { reactive } from "vue";
import { Search as apiSearch } from "/src/api/microTest.js";

export default {
  components: {
    SearchOutlined,
    FormOutlined,
  },
  name: "小医微测信息管理",
  data() {
    return {
      inputs: {
        dateRange: [], // 必须是 moment 对象数组
        dateType: undefined,
      },
      total: 0,
      current: 1,
      data: [],
      columns: [
        { title: "日期", dataIndex: "date", key: "date", width: "10%" },
        { title: "客户", dataIndex: "customerName", key: "customerName", width: "10%", slots: { customRender: "customerName" }, },
        { title: "电话", dataIndex: "phone", key: "phone", width: "10%", slots: { customRender: "phone" }, },
        { title: "是否新客", dataIndex: "isNewCustomer", key: "isNewCustomer", width: "10%" },
        { title: "来源", dataIndex: "source", key: "source", width: "10%" },
        {
          title: "当日看诊信息",
          dataIndex: "doctorName",
          key: "doctorName",
          width: "15%",
          slots: { customRender: "doctorName" },
        },
        {
          title: "小医微测",
          dataIndex: "microTestResult",
          key: "microTestResult",
          width: "15%",
          slots: { customRender: "microTestResult" },
        },
        
        {
          title: "操作",
          key: "operation",
          width: "15%",
          slots: { customRender: "operation" },
        },
      ],
    };
  },
  mounted() {
    this.setDefaultDate();
    this.search("");
  },
  methods: {
    // 设置默认时间为 6 天前到今天（moment 对象）
    setDefaultDate() {
      const today = moment();
      const sixDaysAgo = moment().subtract(6, "days");
      this.inputs.dateRange = [sixDaysAgo, today];
      this.inputs.dateType = undefined;
    },

    // 快捷日期类型切换
    handleChangeDateType() {
      this.inputs.dateRange = [];
      this.setDateByType(this.inputs.dateType);
    },

    // 手动选择日期后清除快捷类型
    handleChangeDate() {
      this.inputs.dateType = undefined;
    },

    // 根据 dateType 设置 dateRange（moment 对象）
    setDateByType(type) {
      let start, end;
      const now = moment();

      switch (type) {
        case "today":
          start = end = now;
          break;
        case "week":
          start = moment().subtract(6, "days");
          end = now;
          break;
        case "month":
          start = moment().startOf("month");
          end = now;
          break;
        case "year":
          start = moment().subtract(1, "year").startOf("year");
          end = now;
          break;
        default:
          return;
      }

      this.inputs.dateRange = [start, end];
    },

    resetForm() {
      this.setDefaultDate();
      this.search("");
    },

    goDoctor(record) {
      console.log("跳转至医生详情:", record.doctorId);
      // this.$router.push(`/doctor/detail/${record.doctorId}`);
    },

    goMicroTest(record) {
      console.log("跳转至微测详情:", record.microTestId);
      // this.$router.push(`/microtest/detail/${record.microTestId}`);
    },

    async search(pagination) {
      // 构建参数
      let params = {
        includeMr: true,
        pageSize: this.$store.state.tableSize,
        current: pagination?.current || 1,
      };

      // 优先使用手动选择的日期范围
      if (this.inputs.dateRange && this.inputs.dateRange.length === 2) {
        params.dateFrom = this.inputs.dateRange[0].format("YYYY-MM-DD");
        params.dateTo = this.inputs.dateRange[1].format("YYYY-MM-DD");
      } else {
        // 没有手动选 → 按 dateType 或默认（6天）
        if (this.inputs.dateType) {
          this.setDateByType(this.inputs.dateType);
        } else {
          this.setDefaultDate();
        }
        params.dateFrom = this.inputs.dateRange[0].format("YYYY-MM-DD");
        params.dateTo = this.inputs.dateRange[1].format("YYYY-MM-DD");
      }

      try {
        const res = await apiSearch(params);
        if (res.errCode === 0) {
          this.total = res.data.total;
          this.data = res.data;
        } else {
          this.$message.error("查询失败");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("请求异常");
      }
    },
  },
};
</script>